import { compose } from 'recompose';

import MetaEdit from './MetaEdit';

const enhance = compose();

export default enhance(MetaEdit);
